var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginPageStoreWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1253_173126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2501 16.5156H21.9999V15.0156C21.9999 13.6377 20.8781 12.5156 19.5 12.5156C18.1219 12.5156 17.0001 13.6377 17.0001 15.0156V16.5156H16.7499C15.785 16.5156 15 17.3005 15 18.2657V21.7656C15 22.7307 15.785 23.5157 16.7499 23.5157H22.2501C23.215 23.5157 24 22.7307 24 21.7656V18.2657C24 17.3005 23.215 16.5156 22.2501 16.5156ZM18.5001 15.0156C18.5001 14.4646 18.949 14.0156 19.5 14.0156C20.051 14.0156 20.4999 14.4646 20.4999 15.0156V16.5156H18.5001V15.0156Z",
    fill: "#50429B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 18.2657C13.5 16.9156 14.3271 15.7566 15.5001 15.2657V15.0156C15.5001 14.4077 15.6469 13.8376 15.891 13.3206C15.1349 12.8135 14.2269 12.5156 13.2501 12.5156H4.74994C2.13098 12.5156 0 14.6466 0 17.2656V20.7656C0 21.1796 0.335999 21.5156 0.75 21.5156H13.5V18.2657Z",
    fill: "#50429B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 5.51569C14.0001 8.2771 11.7615 10.5156 9.00006 10.5156C6.23865 10.5156 4 8.2771 4 5.51569C4 2.75427 6.23865 0.515625 9.00006 0.515625C11.7615 0.515625 14.0001 2.75427 14.0001 5.51569Z",
    fill: "#50429B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1253_173126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginPageStoreWeb);
export default __webpack_public_path__ + "static/media/login-page-store-web.e2bee56e3e081a267e24aaa103ffed67.svg";
export { ForwardRef as ReactComponent };